import { render, staticRenderFns } from "./WelcomeProducts.vue?vue&type=template&id=067d5df8&scoped=true&"
import script from "./WelcomeProducts.vue?vue&type=script&lang=js&"
export * from "./WelcomeProducts.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./WelcomeProducts.vue?vue&type=style&index=0&id=067d5df8&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "067d5df8",
  null
  ,true
)

export default component.exports